// extracted by mini-css-extract-plugin
export default {"button":"LKe6F","link":"_6Aph4","orderInformation":"Js7MA","orderNumber":"Fim-x","placedOn":"g4Iym","tickets":"y9fTF","summaryDetails":"KNcAs","actions":"cfrha"};